'use client';

import { FadeIn } from '../../animation/FadeIn.jsx';
import { cn } from '../../../lib/utils.js';

/**
 * Label/Wert-Tabelle. item: { label, value }.
 */
export function SpecsBlock({ background, eyebrow, headline, items = [] }) {
  return (
    <section className={cn('py-20 md:py-32', background)}>
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <FadeIn>
          <div className="max-w-4xl mx-auto">
            {(eyebrow || headline) && (
              <div className="text-center mb-12">
                {eyebrow && (
                  <p className="text-accent-dark dark:text-accent font-semibold uppercase tracking-wider text-sm mb-2">
                    {eyebrow}
                  </p>
                )}
                {headline && (
                  <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-gray-900 dark:text-gray-100">
                    {headline}
                  </h2>
                )}
              </div>
            )}
            <div className="max-w-2xl mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700 shadow-sm">
              {items.map((item, index) => (
                <div
                  key={index}
                  className={cn(
                    'flex justify-between items-center px-6 py-4',
                    index % 2 === 0 ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                  )}
                >
                  <span className="font-semibold text-gray-900 dark:text-gray-100">{item.label}</span>
                  <span className="text-gray-600 dark:text-gray-400 text-sm text-right">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
